/**
 * Given an array of incentives and an array of tags,
 * yield the incentives that have one or more of the
 * tags
 */
const filterIncentivesByTags = (incentives, tags) => {
  return incentives.filter((incentive) => {
    return incentive.items.some((tag) => tags.includes(tag));
  });
};

export default filterIncentivesByTags;
